import React from 'react';
import './Story.css';

// 1. Import de l'image locale
import storyImg from '../assets/ditecteur.jpeg';

// 2. Assignation de l'image
const STORY_IMAGE = storyImg;

const Story = () => {
  return (
    <section className="story-section">
      <div className="container">
        
        <div className="story-wrapper">
          
          {/* BLOQUE GAUCHE */}
          <div className="story-left-block">
            
            {/* Colonne Label */}
            <div className="label-column">
              <span className="story-label">NOTRE HISTOIRE</span>
            </div>

            {/* Colonne Texte */}
            <div className="text-column">
              <h2>CE QU'IL FAUT SAVOIR <br/> SUR <span className="highlight-title">NOTRE CABINET</span></h2>

              <div className="story-body">
                <p className="lead-text">
                  <strong>ATAA REALTY</strong> est née d’une conviction simple : la valeur ne se proclame pas, elle se construit, se démontre et se transmet.
                </p>

                <p>
                  À l’origine du cabinet, il y a un itinéraire entre ingénierie, expertise immobilière, droit et fiscalité, nourri par une pratique de terrain au Maroc et un dialogue constant avec les standards internationaux.
                </p>

                <p>
                  Le cabinet a été fondé pour répondre à un besoin devenu central sur le marché immobilier marocain : disposer d’analyses indépendantes, structurées et méthodologiquement fondées.
                </p>

                <p>
                  Le nom <strong>ATAA</strong>, qui signifie « la valeur de donner », traduit une approche fondée sur le partage du savoir, la pédagogie dans l’expertise, et l’accompagnement durable.
                </p>

                {/* Points clés */}
                <div className="story-features">
                  <div className="feature-item">
                     <span className="arrow-icon">→</span> 
                     <span>Expertise Indépendante</span>
                     
                  </div>
                  <div className="feature-item">
                     <span className="arrow-icon">→</span> 
                     <span>Vision Stratégique</span>
                  </div>
                  <div className="feature-item">
                     <span className="arrow-icon">→</span> 
                     <span>Rigueur Professionnelle</span>
                  </div>
                  <div className="feature-item">
                     <span className="arrow-icon">→</span> 
                     
                     <span>Standards RICS & IVS</span>
                  </div>
                </div>

                
              </div>
            </div>
          </div>

          {/* BLOQUE DROIT */}
          <div className="story-image-container">
            <div className="dots-pattern"></div>
            <img src={STORY_IMAGE} alt="Directeur ATAA Realty" />
          </div>

        </div>

        {/* Ligne SEO */}
        <div className="seo-footer">
          <p>Cabinet d’expertise immobilière et de conseil basé au Maroc, intervenant auprès d’investisseurs, institutions et acteurs du marché immobilier.</p>
          <p className="small-seo">Les prestations d’ATAA REALTY sont conduites en alignement avec les standards de la RICS et les International Valuation Standards (IVS).</p>
        </div>
      </div>
    </section>
  );
};

export default Story;